// Toast.ts
import Toastify from "toastify-js";

export const newToast = (id: string, message: string) => {
    const el = document.querySelector(`#${id}`)?.cloneNode(true) as HTMLElement;

    if (!el) return;

    el.classList.remove("hidden");

    // 🔹 inject message
    const messageEl = el.querySelector(".toast-message");
    if (messageEl) {
        messageEl.textContent = message;
    }

    Toastify({
        node: el,
        duration: 1500,
        newWindow: true,
        close: true,
        gravity: "bottom",
        position: "left",
        stopOnFocus: true,
    }).showToast();
};
